import { Component, Optional, ChangeDetectionStrategy } from "@angular/core";
import { MatDialogRef, MatDialogModule } from "@angular/material/dialog";
import { CommonModule } from "@angular/common";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";

@Component({
  selector: "app-privacy-policy",
  templateUrl: "./privacy-policy.component.html",
  styleUrls: ["./privacy-policy.component.scss"],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Default,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule]
})
export class PrivacyPolicyComponent {
  readonly isDialogMode: boolean;

  constructor(@Optional() dialogRef: MatDialogRef<PrivacyPolicyComponent>) {
    this.isDialogMode = Object.keys(dialogRef).length > 0; //check if object is not empty
  }
}
